export default __webpack_public_path__ + "static/media/rtg-1.d2e2218a.svg";